<footer class="footer">
  <div class="d-sm-flex justify-content-center justify-content-sm-between">
    <!-- kenny modified -->
    <!-- <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © bootstrapdash.com 2020</span>
    <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Free <a href="https://www.bootstrapdash.com/bootstrap-admin-template/" target="_blank">Bootstrap admin template</a> from BootstrapDash.com
    </span> -->
  </div>
</footer>
